import {
  Grid,
  Hidden,
  Box,
  Breadcrumbs,
  Link,
} from '@material-ui/core';
import React from 'react';
import {
  Route,
  Switch,
  Link as RouterLink,
  useLocation,
} from 'react-router-dom';
import NotFoundPage from '@/pages/notFoundPage';
import AppLayout from '@/components/appLayout';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { Directions } from '@/constants/orderTypeWorkflowsManagement';
import OrderTypesPage from './orderTypes';
import WorkflowsPage from './workflows';

const OrderTypeWorkflowsManagementPage = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const location = useLocation();
  const urlName = location.pathname;

  return (
    <AppLayout className={classes.appLayout} withFooter header>
      <Box marginY={10}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            className={classes.breadcrumbsText}
            color="primary"
            component={RouterLink}
            to="/business-manager/store-profile"
          >
            {t('userManagement.users.business_manager')}
          </Link>
          <Link
            className={classes.breadcrumbsText}
            color="textPrimary"
            component={RouterLink}
            to="/order-types-workflows-management/order-types"
          >
            {t('orderTypeWorkflows.order_type_and_workflows')}
          </Link>
        </Breadcrumbs>
      </Box>
      <Grid container spacing={6}>
        <Hidden smDown>
          <Grid item md={2}>
            <div className={classes.boxSidebar}>
              {Directions?.map((item) => (
                <div
                  key={item.name}
                  className={
                    item.path === urlName
                      ? classes.boxLinkActive
                      : classes.boxLink
                  }
                >
                  <Link
                    underline="none"
                    component={RouterLink}
                    className={classes.linkText}
                    color="textPrimary"
                    to={item.path}
                  >
                    {t(`menu.${item.name}`)}
                  </Link>
                </div>
              ))}
            </div>
          </Grid>
        </Hidden>
        <Grid item md={10}>
          <Switch>
            <Route
              exact
              path="/order-types-workflows-management/order-types"
              component={OrderTypesPage}
            />
            <Route
              exact
              path="/order-types-workflows-management/workflows"
              component={WorkflowsPage}
            />
            {/* Show Not Found page when url does not match */}
            <Route component={NotFoundPage} />
          </Switch>
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default OrderTypeWorkflowsManagementPage;
